import { lazy, type ComponentType, type LazyExoticComponent } from "react";

const chunkFailurePattern =
  /ChunkLoadError|Loading chunk|Failed to fetch dynamically imported module|Importing a module script failed/i;

export function lazyWithRefresh<T extends ComponentType<any>>(
  loader: () => Promise<{ default: T }>,
  key: string,
): LazyExoticComponent<T> {
  return lazy(async () => {
    const recoveryKey = `kidix:chunk-recovery:${key}`;
    try {
      const module = await loader();
      sessionStorage.removeItem(recoveryKey);
      return module;
    } catch (error) {
      const message =
        error instanceof Error
          ? `${error.name}: ${error.message}`
          : String(error);
      if (
        chunkFailurePattern.test(message) &&
        !sessionStorage.getItem(recoveryKey)
      ) {
        sessionStorage.setItem(recoveryKey, "attempted");
        window.location.reload();
      }
      throw error;
    }
  });
}
